export default __webpack_public_path__ + "static/media/Admission.3be55fa0.svg";